import { defineComponent as _defineComponent } from 'vue';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dropdown from 'primevue/dropdown';
import Checkbox from 'primevue/checkbox';
import { ref } from 'vue';
import { FertilizationMethod, WaterWithdrawal } from '@/@types/Enums';
import Utils from '@/Services/Utils';
import { useAxios } from '@/Plugins/axios';
import { useSpinner } from '@/Plugins/spinner';
import { useRoute } from '@/Plugins/ziggy';
export default /*#__PURE__*/ _defineComponent({
    __name: 'Form',
    props: {
        cropManagement: {
            type: Object,
            required: false,
            default: {},
        },
    },
    emits: ['onSave', 'onCancel'],
    setup(__props, { expose, emit: emits }) {
        expose();
        const props = __props;
        const axios = useAxios();
        const spinner = useSpinner();
        const route = useRoute();
        const localCropManagement = ref(Object.assign({}, props.cropManagement));
        const fertilizationMethods = Utils.enumToDropdownOptions(FertilizationMethod, 'FertilizationMethod');
        const waterWithdrawal = Utils.enumToDropdownOptions(WaterWithdrawal, 'WaterWithdrawal');
        const save = () => {
            spinner.show();
            axios
                .put(route('api.crop-management.update', [localCropManagement.value.id]), localCropManagement.value)
                .then((response) => {
                emits('onSave', response.data.data);
            })
                .catch((error) => {
                console.log(error);
            })
                .finally(() => {
                spinner.hide();
            });
        };
        const __returned__ = { props, emits, axios, spinner, route, localCropManagement, fertilizationMethods, waterWithdrawal, save, get InputText() { return InputText; }, get Button() { return Button; }, get Dropdown() { return Dropdown; }, get Checkbox() { return Checkbox; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
